module.exports = __webpack_public_path__ + "img/cxyd-table@2x.bd2c9fbe.png";